export const LOAD_SETTINGS = 'LOAD_SETTINGS'

export function loadDMSettingsAction(settings){
    return {
        type: LOAD_SETTINGS,
        data: settings
    }
}